import { Component,ViewChild,inject,TemplateRef} from '@angular/core';
import { OrdersService } from 'src/app/core/services/orders.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Validators } from '@angular/forms';
import { start } from 'repl';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountService } from 'src/app/core/services/count.service';
import * as moment from 'moment'; 
import { title } from 'process';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent {
  pageSizeOptions: number[] = [10, 20, 50, 100]; 
  headerData: any;
  ogData:any;
  customers: any;
  fullData: any;
  apiData: any = [];
  apiData1:any = [];
  pageIndex:number = 0;
  pageSize:number=4;
  page:any; 
  searchdata:any;  
  superuser:any;
  d2c_name:any;
  portal_name:any;
  portal_account_id:any;
  portal_id:any;
  order1:any;
  searchdata1 = true;
  searchdata2 = true;
  disableButtonCondition: boolean = false;
  createuserform: UntypedFormGroup;
  createuserform1: UntypedFormGroup;
  createuserform2: UntypedFormGroup;
  createuserform4: UntypedFormGroup;
  createuserform8: UntypedFormGroup;
  showOverlay =false  
  length=0
  fullData22 :any
  page_no:number=1;
  isCancelled: boolean = false;
  isOptionSelected: boolean = false;
  config:any;
  headerid:any;
  length1:any;
  username:any;
  date_wise:boolean = false
  paginate: any = {
    length: 0,
    pageIndex: 0,
    pageSize: 10,
    previousPageIndex: 1
    }
    value:any;
    searchchar:boolean = false
    selectedSearchType: 'orders' | 'products' = 'orders'; 
    searchTerm: string = '';
  pageEvent:any;
  startIndex:any
  displayedColumns: string[] | undefined;
  @ViewChild(MatPaginator, { static: true }) paginator:
    | MatPaginator
    | undefined;
  @ViewChild(MatSort, { static: false }) sort: MatSort | undefined;
  start_date = new FormControl();
end_date = new FormControl();
vendorForm = new FormControl('');
vendorForm1 = new FormControl('');
vendorForm2 = new FormControl('');
vendorForm3 = new FormControl('');
vendorForm4 = new FormControl('');
vendorForm5 = new FormControl('');
vendorForm10 = new FormControl('');
search_name = new FormControl('');
search_buymore_sku = new FormControl('');
search_order_id = new FormControl('');
search_awb = new FormControl('');
search_order_item_id = new FormControl('')
search_shopify_order_id = new FormControl('')
search_portal_sku = new FormControl('')
search_qty = new FormControl('')
search_phone_number = new FormControl('')
search_email = new FormControl('')
search_product_id = new FormControl('')
search_courier_partner = new FormControl('')
@ViewChild('InvoicenumberTemplate1') InvoicenumberTemplate1!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate2') InvoicenumberTemplate2!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate3') InvoicenumberTemplate3!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate4') InvoicenumberTemplate4!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate5') InvoicenumberTemplate5!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate6') InvoicenumberTemplate6!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate7') InvoicenumberTemplate7!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate8') InvoicenumberTemplate8!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate9') InvoicenumberTemplate9!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate10') InvoicenumberTemplate10!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate11') InvoicenumberTemplate11!: TemplateRef<any>;
@ViewChild('InvoicenumberTemplate12') InvoicenumberTemplate12!: TemplateRef<any>;


















private modalService = inject(NgbModal);
  fulllength: any;
  @ViewChild('select') select: MatSelect;
    @ViewChild('select1') select1: MatSelect;
        @ViewChild('select2') select2: MatSelect;



  constructor(
    private _order:OrdersService,
    private authService:AuthenticationService,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private countservice : CountService
    ){

  }
  ngOnInit(): void { 
    this.superuser = localStorage.getItem('is_superuser')
   this.initializeDates() ;
   this.initform();  
   this.superuser = localStorage.getItem('is_superuser')
   if(this.superuser == 'true'){
     this.portal_name = localStorage.getItem('portal_name2')
     this.portal_id = localStorage.getItem('portal_id2')
     this.portal_account_id = localStorage.getItem('portal_account_id2')
     this.d2c_name = localStorage.getItem('d2c_name2')

   }
   else{
     this.portal_name = localStorage.getItem('portal_name')
      this.portal_id = localStorage.getItem('portal_id')
     this.portal_account_id = localStorage.getItem('portal_account_id')
     this.d2c_name = localStorage.getItem('d2c_name')
   }
    this.fetchData(this.paginate);
  }
  openDropdown() {
    if (this.select) {
      this.select.open();
    }
  }
    openDropdown1() {
    if (this.select1) {
      this.select1.open();
    }
  }
      openDropdown2() {
    if (this.select2) {
      this.select2.open();
    }
  }
  initform(){
    this.createuserform = this.formBuilder.group({
      agent_remark: ['', [Validators.required]],
      voice_of_customer: ['', [Validators.required]],
      category: ['Select Category', [Validators.required]],
      // status: ['open', [Validators.required]],
      // disposition: ['pending', [Validators.required]],
      support_chat: ['', [Validators.required]],      
    });
    this.createuserform1 = this.formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
      pincode: ['', [Validators.required]],
      financial_status: ['', [Validators.required]],
      email_id: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      title: ['', [Validators.required]],
      shipping_charge: ['', [Validators.required]],
      code: ['', [Validators.required]],
      line_items:this.formBuilder.array(([this.createItemFormGroup()]))
    });

    this.createuserform4 = this.formBuilder.group({
      name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      pincode: ['', [Validators.required]],
      email_id: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      awb: ['', [Validators.required]],
      location_latitude: ['', [Validators.required]],
      location_longitude: ['', [Validators.required]],
      status: ['', [Validators.required]],
    });

    this.createuserform8 = this.formBuilder.group({
      order_id: ['', [Validators.required]],
      reason: ['', [Validators.required]],
    });

    this.createuserform2 = this.formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
      pincode: ['', [Validators.required]],
      payment_method: ['', [Validators.required]],
      email_id: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      payment_method_title: ['', [Validators.required]],
      shipping_charge: ['', [Validators.required]],
      set_paid: ['', [Validators.required]],
      line_items:this.formBuilder.array(([this.createItemFormGroup1()]))
    });
  }
  createItemFormGroup(): FormGroup {
    return this.formBuilder.group({
      product: new FormControl('',[Validators.required]),
      quantity:new FormControl('',[Validators.required]),

    });
  }
  createItemFormGroup1(): FormGroup {
    return this.formBuilder.group({
      product: new FormControl('',[Validators.required]),
      quantity:new FormControl('',[Validators.required]),
    });
  }
  getItemFormArray(): FormArray {
    return this.createuserform1?.get('line_items') as FormArray;
  }
  getItemFormArray1(): FormArray {
    return this.createuserform2?.get('line_items') as FormArray;
  }
  addItem() {
    const itemArray = this.createuserform1.get('line_items') as FormArray;
    itemArray.push(this.createItemFormGroup());
  }
  addItem1() {
    const itemArray = this.createuserform2.get('line_items') as FormArray;
    itemArray.push(this.createItemFormGroup1());
  }
  removeItem(i: number): void {
    const itemsArray = this.createuserform1.get('line_items') as FormArray;
    itemsArray.removeAt(i);
  }
  removeItem1(i: number): void {
    const itemsArray = this.createuserform2.get('line_items') as FormArray;
    itemsArray.removeAt(i);
  }
  initializeDates() {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 6);

    this.start_date.setValue(startDate);
    this.end_date.setValue(endDate);
  }

  fetchData(event:PageEvent) {
    this.superuser = localStorage.getItem('is_superuser')
    if(this.superuser == 'true'){
      this.portal_name = localStorage.getItem('portal_name2')
      this.portal_id = localStorage.getItem('portal_id2')
      this.portal_account_id = localStorage.getItem('portal_account_id2')
      this.d2c_name = localStorage.getItem('d2c_name2')

    }
    else{
      this.portal_name = localStorage.getItem('portal_name')
       this.portal_id = localStorage.getItem('portal_id')
      this.portal_account_id = localStorage.getItem('portal_account_id')
      this.d2c_name = localStorage.getItem('d2c_name')
    }
    this.showOverlay=true 
this.paginate = event;
this.length = +event.length;
this.pageIndex = +event.pageIndex;
this.pageSize = +event.pageSize;
this.startIndex = +event.pageIndex * event.pageSize
let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1
const startdate1 = moment(this.start_date.value).format('YYYY-MM-DD')
const  enddate1 = moment(this.end_date.value).format('YYYY-MM-DD')

 let data = {
   "page":page_no,
   "size":this.pageSize,
   'portal_account_id':this.portal_account_id,
   'start_date':startdate1,
   'end_date':enddate1,
   'filter':{
    'warehouse_id':this.vendorForm1.value ?? '',
    'status':this.vendorForm.value ?? '',
    'payment_method':this.vendorForm10.value ?? '',
     'name':this.search_name.value ?? '',
     'order_id':this.search_order_id.value ?? '',
     'order_item_id':this.search_order_item_id.value ?? '',
     'awb':this.search_awb.value ?? '',
     'shopify_order_id':this.search_shopify_order_id.value ?? '',
     'buymore_sku':this.search_buymore_sku.value ?? '',
     'portal_sku':this.search_portal_sku.value ?? '',
     'qty':this.search_qty.value ?? '',
     'phone_number':this.search_phone_number.value ?? '',
     'email':this.search_email.value ?? '',
     'product_id':this.search_product_id.value ?? '',
     'courier_partner':this.search_courier_partner.value ?? ''

   } 
 };
//  console.log(data)
 this.authService.orders_view(data).subscribe((res: any) => {
  // console.log(res);
  let mes = JSON.parse(res);
  res = mes
  console.log(res.pagination,'pagination')
  if (res.Data.length > 0){
      this.length= res.pagination.total_record_count
  this.fulllength =  res.pagination.total_record_count
  }

  // console.log(mes);
   if (mes.statusCode === 200) {
     this.showOverlay = false;
       this.fullData = mes.Data;  
       this.ogData =mes.Data
     this.headerData = mes.header;
     this.getData(this.fullData); 
    this.modalService.dismissAll('Close click'); 


   } 
   else{
    if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
      // this.authService.logout()
      this.showOverlay=false
      this.router.navigate(['/auth/login'])
    }
    else{
      this.toastr.error(res.error, "");
      this.showOverlay = false; 
    }
    // this.showOverlay= false

   }
  
 }, 
 (error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});
}

fetchData1(){
  this.fetchData2(this.paginate)
}


placeholder_name = 'Search For Order Id'


setplaceholder(data:any){
    this.placeholder_name=data
    this.isOptionSelected = true;
    if(data === 'phone'){
      this.placeholderText = 'Search For Phone No'
    }
    else if(data === 'awb'){
      this.placeholderText = 'Search For Awb'
    }
    else if(data === 'email'){
      this.placeholderText = 'Search For Email'

    }
    else{
      this.placeholderText = 'Search For Order Id'
    }
    console.log(this.placeholder_name)

}

onSelectChange(event: any) {
  const selectedValue = event.target.value;
  this.setplaceholder(selectedValue);
}
placeholderText = 'Search For Order Id'
selectedOption = 'order_id'

fetchData2(event:PageEvent) {
  this.paginate = event;
this.length = +event.length;
this.pageIndex = +event.pageIndex;
this.pageSize = +event.pageSize;
this.startIndex = +event.pageIndex * event.pageSize
let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }

//   this.showOverlay=true 
// this.paginate = event;
// this.length = +event.length;
// this.pageIndex = +event.pageIndex;
// this.pageSize = +event.pageSize;
// this.startIndex = +event.pageIndex * event.pageSize
// let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1
const startDate = this.start_date.value.toISOString().split('T')[0]; // Extract date part
const endDate = this.end_date.value.toISOString().split('T')[0]; // Extract date part
const formattedDate1 = this.start_date!.value 
const formattedDate2 = this.end_date!.value
this.showOverlay=true 
const startdate1 = moment(this.start_date.value).format('YYYY-MM-DD')
const  enddate1 = moment(this.end_date.value).format('YYYY-MM-DD')
// console.log(statrdata1,'statrdata1')




let data = {
 "page":page_no,
 "size":this.pageSize,
 'portal_account_id':this.portal_account_id,
 'start_date':startdate1,
 'end_date':enddate1,


 
};
// console.log(data)
this.authService.orders_view(data).subscribe((res: any) => {
// console.log(res);
let mes = JSON.parse(res);
res = mes
// console.log(mes);
 if (mes.statusCode === 200) {
   this.showOverlay = false;
  //  this.toastr.success(res.message, ''); 
  this.date_wise = true
  this.fulllength = mes.pagination.total_record_count
   this.length=mes.pagination.total_record_count
     this.fullData = mes.Data; 
     this.ogData =mes.Data
   this.headerData = mes.header;
   this.getData(this.fullData); 
 } 
 else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(mes.error, "");
    this.showOverlay = false; 
  }
  // this.showOverlay = false;
 }

}, 
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});
}

getData(data:any) {
  this.apiData = data;
  // console.log("this.apiData",this.apiData); 
  // console.log(this.apiData);
  // this.filteredPortal = this.apiData
  this.headerData.actions = "Action"; 
  delete this.headerData.tracking_url;
  this.displayedColumns = Object.keys(this.headerData);
  this.customers = new MatTableDataSource(this.apiData);
  this.customers.sort = this.sort;
  // this.customers.paginator = this.paginator;
}
filteredPortal = [
  {status:'cancelled'},
  {status:'dispatched'},
  {status:'Delivered'},
  {status:'In Transit'},
  {status:'packed'},
  {status:'created'},
  {status:'on hold'},
]

filteredPortal1 = [
   {name:'Mumbai',id:3},
   {name:'Kolkata',id:7},
   {name:'Hyderabad',id:12},
   {name:'Delhi',id:10},
   {name:'Banglore',id:4},


]

filteredPortal2 = [
   {name:'Prepaid'},
   {name:'COD'}


]

orderData:any

show_data(data:any){
  this.orderData = data
  console.log(data,'data')
}



onStartDateSelected(event: MatDatepickerInputEvent<Date>) {
  const startDate = event.value;
  const maxEndDate = this.calculateMaxEndDate(startDate);
  this.end_date.setValue(null); // Reset the end date when start date changes
  this.end_date.enable(); // Enable the end date input
  this.end_date.setValidators([
    Validators.required,
    this.endDateValidator.bind(this, startDate, maxEndDate)
  ]);
}

private calculateMaxEndDate(startDate: Date): Date {
  const maxEndDate = new Date(startDate);
  maxEndDate.setDate(maxEndDate.getDate() + 30);
  return maxEndDate;
}

private endDateValidator(startDate: Date, maxEndDate: Date, control: FormControl): { [key: string]: any } | null {
  const endDate = control.value;
  if (endDate && endDate > maxEndDate) {
    return { maxEndDateExceeded: true };
  }
  return null;
}
combinedValue:any;

applyFilter(filterValue: string) {
  this.searchTerm = filterValue; 
  if (this.selectedOption && this.searchTerm) {
    this.combinedValue = `${this.selectedOption}:${this.searchTerm}`;
    this.ordersearch(this.searchTerm,this.selectedOption);
  }
}
  // console.log(filterValue.value);
  // this.customers.filter = filterValue.value.trim().toLowerCase();
  // //  this. refreshIcon=true
  // if (this.customers.paginator) {
  //   this.customers.paginator.firstPage();
  // }

data:any;
onSearchChange() {
  // Trigger API call when the search term changes
}
ordersearch(value:any,key:any){
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  // console.log(key);
  this.showOverlay=true 


  if (key === 'order_id') {
    const cleanedOrderId = value.replace(/\t/g, ''); // Remove tab characters
    this.data = {
      'order_id': cleanedOrderId,
      'portal_account_id': this.portal_account_id
    };
  } else {
    const cleanedOrderId = value.replace(/\t/g, ''); // Remove tab characters
    this.data = {
      'awb': cleanedOrderId,
      'portal_account_id': this.portal_account_id
    };
  }
  
  // console.log(this.data)
 
 this.authService.orders_search(this.data).subscribe((res: any) => {
  // console.log(res);
  let mes = JSON.parse(res);
  res = mes
  // console.log(mes);
  if (mes.statusCode === 200) {
    this.showOverlay = false;
    this.searchdata = mes.Data
    // console.log(this.searchdata,'this.serachdata')
  
   
  } 
  else{
    if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
      // this.authService.logout()
      this.showOverlay=false
      this.router.navigate(['/auth/login'])
    }
    else{
      this.toastr.error(res.error, "");
      this.showOverlay = false; 
    }
    
    // this.showOverlay=false

  }
 },
 (error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});

}
cancelSearch() {
  this.isCancelled = true;
  this.searchTerm = ''; // Clear the search term
  // You can add additional logic here based on your requirements
}
// applyFilter1(filterValue: any) {
//   // console.log(filterValue.value)
//   this.customers.filter = filterValue.value.trim().toLowerCase();
// //  this. refreshIcon=true
//   if (this.customers.paginator) {
//     this.customers.paginator.firstPage();
//   }
// }
applyFilter1(filterValue: any) {
  this.searchchar = true;
  this.value = filterValue;

  // Reset pagination
  this.paginate = {
    length: 0,
    pageIndex: 0,
    pageSize: 10,
    previousPageIndex: 1
  };

  console.log(this.placeholderText, 'this.placeholderText');

  // Reset all form values first
  this.vendorForm2.setValue('');
  this.vendorForm3.setValue('');
  this.vendorForm4.setValue('');
  this.vendorForm5.setValue('');

  // Set value only for the relevant form field
  switch (this.placeholderText) {
    case 'Search For Order Id':
      this.vendorForm2.setValue(filterValue);
      break;
    case 'Search For Awb':
      this.vendorForm3.setValue(filterValue);
      break;
    case 'Search For Phone No':
      this.vendorForm4.setValue(filterValue);
      break;
    case 'Search For Email':
      this.vendorForm5.setValue(filterValue);
      break;
    default:
      // Optional: Handle unknown placeholders
      console.warn('Unknown placeholderText:', this.placeholderText);
      break;
  }

  // Fetch data with new filter
  this.fetchData(this.paginate);
}

cancel_order(data:any){
  // console.log(data,'consoledaat')
  localStorage.setItem('order_data', JSON.stringify(data)); 
  this.order_status(data)
  // this.router.navigate(['/cancel'])



}

clear_filters(){
  this.search_name.setValue('')
  this.search_order_id.setValue('')
  this.search_awb.setValue('')
  this.search_order_item_id.setValue('')
  this.search_awb.setValue('')
  this.search_shopify_order_id.setValue('')
  this.search_buymore_sku.setValue('')
  this.search_portal_sku.setValue('')
  this.search_qty.setValue('')
  this.search_phone_number.setValue('')
  this.search_email.setValue('')
  this.search_product_id.setValue('')
  this.search_courier_partner.setValue('')
  this.vendorForm.setValue(''),
  this.vendorForm10.setValue(''),
  this.vendorForm1.setValue('')
                this.searchTerm = ''
                this.fetchData(this.paginate)
}
mes: any[] = []; 
searchdata3: any[] = [];
order2:any

order_status(order:any){
  this.showOverlay = true;
  this.order1= order.order_id
  this.order2 = order.dd_id
  // console.log(this.order1,'order1')

  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  let data ={
    'portal_id':this.portal_id,
    'portal_account_id':this.portal_account_id,
    'order_id': this.order1,
    // 'payment_method':this.fullData[0].payment_method,
    // 'reason': this.order_id
  }
  // console.log(data,'kjhgfdsasdfghjklkjhgfd')
  this.authService.order_status(data).subscribe((res: any) => {
    // console.log(res);
    let mes = JSON.parse(res);
    res = mes
    // console.log(mes);
    if (mes.statusCode === 200) {
      this.showOverlay = false;
      if(mes.message =='order is not available for return or cancellation'){
        this.toastr.error(mes.message, ''); 

      }
      else{
        this.toastr.success(mes.message, '');

      }
      this.searchdata1 = mes.is_return_avialable
      this.searchdata2 = mes.is_cancel_avialable
      if (this.searchdata1 || this.searchdata2) {
        this.router.navigate(['/page/retailripple/cancel']);
      } else {
      }
      this.disableButtonCondition = !this.searchdata1 && !this.searchdata2;

      // Iterate through searchdata and set disableButton for the specific row
      this.fullData.forEach(item => {
        // Set disableButton based on your conditions
        item.disableButton = item.dd_id === this.order2 && !this.searchdata1 && !this.searchdata2;
      });
      // console.log(this.fullData,'searchdata3')

}
else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(res.error, "");
    this.showOverlay = false; 
    // console.log('error mesg',res)
  }


}
},
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});


}
openVerticallyCentered(content: TemplateRef<any>,row:any) {
  this.modalService.open(content, { centered: true,size: 's'});
  this.headerid = row.order_id
  // console.log(row,'row data')
  localStorage.setItem('portali',row.portal_id)
  localStorage.setItem('portal_idd',row.portal_account_id)
  localStorage.setItem('portal_iddd',row.order_id)
  localStorage.setItem('portal_idddd',row.awb)



}

openVerticallyCentered5(content: TemplateRef<any>) {
  this.modalService.open(content, { centered: true,size: 'lg'});


}
ticket_create(){
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  this.username = localStorage.getItem('username')
  let data ={
    'portal_id': this.portal_id,
    'portal_account_id':this.portal_account_id,
    'order_id': localStorage.getItem('portal_iddd'),
    'awb': localStorage.getItem('portal_idddd'),
    'agent_remark':this.createuserform.value.agent_remark,
    'voice_of_customer':this.createuserform.value.voice_of_customer,
     'is_order_issue':'true',
     'category':this.createuserform.value.category,
     'disposition':'pending',
     'status':'open',
     'raised_by':localStorage.getItem('username'),
     'is_notification_read':'false'
  


  
  }
  data['support_chat'] = {
    [this.username] :this.createuserform.value.support_chat
  } 
  this.showOverlay=true
  this.authService.ticket_create(data).subscribe((res: any) => {
    // console.log(res,'ticket data');
    let mes = JSON.parse(res);
    res =mes
    // console.log(mes);
    if (mes.statusCode === 200) {
      this.showOverlay=false
      this.toastr.success(mes.success, "");
      this.modalService.dismissAll('Close click');

      

}
else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(mes.error, "");
    this.showOverlay = false; 
    this.modalService.dismissAll('Close click');

  }


}
},
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});

}
selectedPageSize: number = 10; // Default page size

onPageSizeChange(pageSize: number) {
  this.selectedPageSize = pageSize;
  console.log(' this.selectedPageSize', this.selectedPageSize)
}
not_allow_only_num_and_spl_char(value: any,inpu_feild_name:any){
  if (value) {
    if (/^[0-9]*$/.test(value)) {
      this.toastr.error(""+inpu_feild_name+" is containing only numbers. Please fill correctly.");
      return { nonAlphanumeric: true };
    }
    if (/^[^a-zA-Z0-9]*$/.test(value)) {
      this.toastr.error(""+inpu_feild_name+" is containing only special characters. Please fill correctly.");
      return { nonAlphanumeric: true };
    }
  }
  return null;
}
only_spl_and_num_not_accept(event: any,input_name:any,){
  const value = event.target.value;
    this.not_allow_only_num_and_spl_char(value,input_name); 
  
}


fetchData3(event:PageEvent,data1:any) {

 
  this.showOverlay = true
  this.paginate = event;
this.length = +event.length;
this.pageIndex = +event.pageIndex;
this.pageSize = +event.pageSize;
this.startIndex = +event.pageIndex * event.pageSize
let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }

let data = {
 "page":page_no,
 "size":this.pageSize,
 'portal_account_id':this.portal_account_id,
 'search':data1

};

// console.log(data)
this.authService.orders_search2(data).subscribe((res: any) => {
// console.log(res);
let mes = JSON.parse(res);
res = mes
// console.log(mes);
 if (mes.statusCode === 200) {
   this.showOverlay = false;
  //  this.toastr.success(res.message, ''); 
  this.date_wise = true
  this.fulllength = mes.total_length
   this.length=mes.total_length
     this.fullData = mes.Data; 
     this.ogData =mes.Data
   this.headerData = mes.headers;
   this.getData(this.fullData); 
 } 
 else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(res.error, "");
    this.showOverlay = false; 
  }
  // this.showOverlay = false;
 }

}, 
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});
}


fetchData4(event:PageEvent,data1:any) {

  if(data1 === 'packed'){
   data1 = 'dispatched'
  }
  else if(data1 === 'dispatched'){
   data1 = 'packed'
  }
 this.showOverlay = true
 this.paginate = event;
this.length = +event.length;
this.pageIndex = +event.pageIndex;
this.pageSize = +event.pageSize;
this.startIndex = +event.pageIndex * event.pageSize
let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1
 this.superuser = localStorage.getItem('is_superuser')
 if(this.superuser == 'true'){
   this.portal_name = localStorage.getItem('portal_name2')
   this.portal_id = localStorage.getItem('portal_id2')
   this.portal_account_id = localStorage.getItem('portal_account_id2')
   this.d2c_name = localStorage.getItem('d2c_name2')

 }
 else{
   this.portal_name = localStorage.getItem('portal_name')
    this.portal_id = localStorage.getItem('portal_id')
   this.portal_account_id = localStorage.getItem('portal_account_id')
   this.d2c_name = localStorage.getItem('d2c_name')
 }

let data = {
"page":page_no,
"size":this.pageSize,
'portal_account_id':this.portal_account_id,
'search':data1

};

// console.log(data)
this.authService.orders_search2(data).subscribe((res: any) => {
// console.log(res);
let mes = JSON.parse(res);
res = mes
// console.log(mes);
if (mes.statusCode === 200) {
  this.showOverlay = false;
 //  this.toastr.success(res.message, ''); 
 this.date_wise = true
 this.fulllength = mes.total_length
  this.length=mes.total_length
    this.fullData = mes.Data; 
    this.ogData =mes.Data
  this.headerData = mes.headers;
  this.getData(this.fullData); 
} 
else{
 if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
   // this.authService.logout()
   this.showOverlay=false
   this.router.navigate(['/auth/login'])
 }
 else{
   this.toastr.error(res.error, "");
   this.showOverlay = false; 
 }
 // this.showOverlay = false;
}

}, 
(error) => {
 this.showOverlay = false;
 if (error.status === 502) {
   this.toastr.error("502 Bad Gateway", "An error occurred");
 } else {
   this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
 }
});
}



fetchData11() {
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  this.showOverlay=true 
  console.log(this.d2c_name,'d2c_name')


let data = {

 'portal_account_id':parseInt(this.portal_account_id),
 'portal_id':parseInt(this.portal_id)


 
};
this.authService.product_get_order(data).subscribe((res: any) => {
let mes = JSON.parse(res);
res = mes
 if (mes.statusCode === 200) {
   this.showOverlay = false;
   this.fullData22 = mes.body
   console.log(this.fullData22,'fullData22')


 } 
 else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(res.error, "");
    this.showOverlay = false; 
  }

 }

}, 
(error) => {
this.showOverlay = false;
if (error.status === 502) {
  this.toastr.error("502 Bad Gateway", "An error occurred");
} else {
  this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
}
});
}


openVerticallyCentered1(content: TemplateRef<any>) {
  this.fetchData11()
  this.modalService.open(content, { centered: true,size: 'lg'});
  if (this.d2c_name === 'woocommerce'){

  }
}

openVerticallyCentered4(content: TemplateRef<any>) {
  this.modalService.open(content, { centered: true,size: 'lg'});

}

create_order(){
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  this.showOverlay=true 


let data = this.createuserform1.value
this.value = this.createuserform1.value.line_items
console.log(this.createuserform1.value.line_items)
data['portal_id'] = this.portal_id
data['portal_account_id'] = this.portal_account_id
const productsToFind = this.value.map(item => item.product);
const productQuantitiesMap = this.value.reduce((acc, item) => {
  acc[item.product] = item.quantity;
  return acc;
}, {});
const matchedProducts = this.fullData22
    .filter(item => productsToFind.includes(item.product_name))
    .map(item => ({
        "portal_sku": item.shopify_portal_sku,
        "selling_price": item.shopify_upload_selling_price,
        "quantity": productQuantitiesMap[item.product_name] || 0,
        "variant_id": item.shopify_listing_id, // Assuming variant_id maps to shopify_listing_id
        "product_name": item.product_name
    }));console.log(matchedProducts);
data['line_items'] = matchedProducts

  this.authService.create_order(data).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 201) {
       this.showOverlay = false;
       this.toastr.success(res.success);
       this.modalService.dismissAll()

    
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(res.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });

}

create_order1(){
  this.superuser = localStorage.getItem('is_superuser')
  if(this.superuser == 'true'){
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else{
    this.portal_name = localStorage.getItem('portal_name')
     this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  this.showOverlay=true 


let data = this.createuserform2.value
this.value = this.createuserform2.value.line_items
console.log(this.createuserform2.value.line_items)
data['portal_id'] = this.portal_id
data['portal_account_id'] = this.portal_account_id
const productsToFind = this.value.map(item => item.product);
const productQuantitiesMap = this.value.reduce((acc, item) => {
  acc[item.product] = item.quantity;
  return acc;
}, {});
const matchedProducts = this.fullData22
    .filter(item => productsToFind.includes(item.product_name))
    .map(item => ({
        "quantity":  productQuantitiesMap[item.product_name] || 0,
        "product_id": item.shopify_listing_id, // Assuming variant_id maps to shopify_listing_id
    }));console.log(matchedProducts);
data['line_items'] = matchedProducts

console.log(data,'jhgfdsdfghjk')

  this.authService.create_order(data).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 200) {
       this.showOverlay = false;
       this.toastr.success(res.success);
       this.modalService.dismissAll()

    
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(res.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });

}
numericOnly(event): boolean {    
  let patt = /^[0-9 .]+$/;
  let result = patt.test(event.key);
  return result;
}




applyFilterVendor(filterValue: string) {
  if (filterValue.length==0) {
    this.filteredPortal=this.apiData
  }  
  else{
    this.apiData = this.apiData.filter((item: any) => {
      const actualValueWithoutSpaces = item.status.replace(/\s/g, '').toLocaleLowerCase();
      const filterValueWithoutSpaces = filterValue.replace(/\s/g, '').toLocaleLowerCase();        
      return actualValueWithoutSpaces.includes(filterValueWithoutSpaces);
    });      
  }
  console.log(this.apiData)
}
closedFilter() {
  console.log('log')
  this.searchchar = true
  this.value = this.vendorForm.value
  this.paginate = {
    length: 0,
    pageIndex: 0,
    pageSize: 10,
    previousPageIndex: 1
    }
      if( this.vendorForm.value === 'packed'){
    this.vendorForm.setValue('dispatched')
  }
  else if( this.vendorForm.value === 'dispatched'){
        this.vendorForm.setValue('packed')
  }
  this.fetchData(this.paginate)

}

closedFilter1() {
  console.log('log')
  this.searchchar = true
  this.value = this.vendorForm.value
  this.paginate = {
    length: 0,
    pageIndex: 0,
    pageSize: 10,
    previousPageIndex: 1
    }
  this.fetchData(this.paginate)

}
name11:any
phone11:any
email_id11:any;
awb11:any
address11:any
pincode11:any
status11:any

openVerticallyCentered2(content: TemplateRef<any>,row:any) {
  console.log(row,'dataa')
  this.name11 = row.name
  this.phone11 = row.phone
  this.email_id11 = row.email_id
  this.awb11 = row.awb
  this.address11 = row.address
  this.pincode11 = row.pincode
  this.status11 = row.status
  localStorage.setItem('edit_id',row.order_id)

  this.modalService.open(content, { centered: true,size: 'lg'});
}


update_order(){
  this.superuser = localStorage.getItem('is_superuser')

  if (this.superuser == 'true') {
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else {
    this.portal_name = localStorage.getItem('portal_name')
    this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  let data = this.createuserform4.value
 data['order_id'] = localStorage.getItem('edit_id')
 data['portal_id'] = this.portal_id
 data['portal_account_id'] = this.portal_account_id
  this.authService.update_order(data).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 200) {
       this.showOverlay = false;
       this.toastr.success(mes.success);
       this.modalService.dismissAll()

    
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(res.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });

}
 partial_order(){
  this.superuser = localStorage.getItem('is_superuser')

  if (this.superuser == 'true') {
    this.portal_name = localStorage.getItem('portal_name2')
    this.portal_id = localStorage.getItem('portal_id2')
    this.portal_account_id = localStorage.getItem('portal_account_id2')
    this.d2c_name = localStorage.getItem('d2c_name2')

  }
  else {
    this.portal_name = localStorage.getItem('portal_name')
    this.portal_id = localStorage.getItem('portal_id')
    this.portal_account_id = localStorage.getItem('portal_account_id')
    this.d2c_name = localStorage.getItem('d2c_name')
  }
  let data = this.createuserform8.value
  console.log(data,'data')
  this.authService.partial_order(data).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 200) {
       this.showOverlay = false;
       this.fetchData(this.paginate)
       this.toastr.success(res.success);
       this.modalService.dismissAll()

    
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(mes.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });

}

update_status(data:any){
    this.showOverlay = true
  let payload = {
    'portal_id':this.portal_id,
    'portal_account_id':this.portal_account_id,
    'order_id':data

  }
    this.authService.status_update(payload).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 200) {
       this.showOverlay = false;
       this.fetchData(this.paginate)
       this.toastr.success(res.success);
      //  this.fetchData(this.paginate);
       this.modalService.dismissAll()

    
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(mes.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });
}

open(content:any){
  this.modalService.open(content, { centered: true });
}

download1(){
  this.search_name.setValue('')
  this.search_order_id.setValue('')
  this.search_awb.setValue('')
  this.search_order_item_id.setValue('')
  this.search_awb.setValue('')
  this.search_shopify_order_id.setValue('')
  this.search_buymore_sku.setValue('')
  this.search_portal_sku.setValue('')
  this.search_qty.setValue('')
  this.search_phone_number.setValue('')
  this.search_email.setValue('')
  this.search_product_id.setValue('')
  this.search_courier_partner.setValue('')
  this.vendorForm.setValue(''),
  this.vendorForm10.setValue(''),
  this.vendorForm1.setValue('')
  this.fetchData(this.paginate)

}
download2(){
this.fetchData(this.paginate)

}

}
